export const iamAccountIsRoot = {
  type: "boolean"
};
